import { openBlock as r, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, l) {
  return r(), t("svg", o, [...l[0] || (l[0] = [
    e("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      e("path", { d: "M16.118 8.678 13.05 5.61l-7.413 7.413v3.068h3.068zm-8.845 5.776v-.752l5.777-5.777.752.753-5.776 5.776zM18.49 6.306a.815.815 0 0 0 0-1.154l-1.914-1.915a.82.82 0 0 0-1.154 0l-1.497 1.498 3.068 3.068zm1.874 11.421H4V20h16.364z" })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
